module.exports = __webpack_public_path__ + "static/closed-for-the-winter-8d7396b3cbc65bb738316091077e93cd.png";